export enum AuthenticationState {
  LogIn = 1,
  ForgotPassword = 2,
  LoginSelection = 3,
  OneTimeLoginEmail = 4,
  OneTimeLoginSms = 5,
  EmailConfirmation = 6,
  ExternalSSO = 7,
  ReceptionCode = 8,
  MsalSSO = 9,
}
